import escapeHtml from 'escape-html';
import parse from 'html-react-parser';

export const encodeHtmlText = (value?: string | null) => {
  if (!value) {
    return '';
  }
  return escapeHtml(value);
};

export const getParsedText = (value?: string | null) => {
  if (!value) {
    return '';
  }
  const parsedText = parse(value);
  return typeof parsedText === 'object' ? value : parsedText;
};
